import { createCRUDHook } from './createCRUDHook';
import { HardwareProductDto } from 'utils/models';
import { TBL_HARDWARE_PRODUCT } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<HardwareProductDto>(
  {
    entityName: 'HardwareProduct',
    endpoint: TBL_HARDWARE_PRODUCT,
  }
);

export const HardwareProductContext = Context;
export const useHardwareProductManager = useManager;
export const useHardwareProduct = useConsumer;
